import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../shared/modal/modal";
import styles from "./change-status-report-modal.module.scss";
import Input from "../../../../ui-kit/Input/input";
import Dropdown from "../../../../ui-kit/dropdown/dropdown";
import {
  fetchReports,
  ReportRow,
} from "../../../../../services/reducers/reports-journal";
import { useAppSelector } from "../../../../../hooks/useAppSelector";
import Button from "../../../../ui-kit/button/button";
import { changeReportStatus } from "../../../../../services/api";
import { useAppDispatch } from "../../../../../hooks/useAppDispatch";

interface ChangeStatusReportModalProps {
  selectedRowData: ReportRow;
  onClose: () => void;
}

const ChangeStatusReportModal: FC<ChangeStatusReportModalProps> = ({
  selectedRowData,
  onClose,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { options } = useAppSelector((state) => state.studyCreation);
  const [status, setStatus] = useState<string>(selectedRowData.status);

  const handleSaveChangeStatusReport = async () => {
    await changeReportStatus(selectedRowData.id, status);
    dispatch(fetchReports());
    onClose();
  };

  return (
    <Modal closeClass={styles.closeBtn} onClose={onClose}>
      <h2 className={styles.title}>{t("change-status-report-modal.title")}</h2>
      <div className={styles.modalWrapper}>
        <div className={styles.draftStatusGroup}>
          <Input
            classes={{
              label: styles.label,
              input: styles.formField,
            }}
            label={t("change-status-report-modal.drafterLabel")}
            value={selectedRowData.userName}
            disabled={true}
          />
          <Dropdown
            classes={{
              label: styles.label,
              dropdown: styles.formField,
            }}
            title={t("change-status-report-modal.statusLabel")}
            options={options.statusOptions}
            value={selectedRowData.status}
            onChange={(selectedOption) => {
              if (typeof selectedOption === "string") {
                setStatus(selectedOption);
              }
            }}
          />
        </div>
        <Input
          classes={{
            input: styles.formField,
            label: styles.label,
          }}
          label={t("change-status-report-modal.cityNameLabel")}
          value={selectedRowData.cityName}
          onChange={() => {}}
          disabled={true}
        />
        <Dropdown
          classes={{
            label: styles.label,
            dropdown: styles.formField,
          }}
          title={t("change-status-report-modal.governoratesLabel")}
          options={options.governoratesOptions}
          value={selectedRowData.governorate}
          disabled={true}
        />

        <div className={styles.groupBtn}>
          <Button
            onClick={handleSaveChangeStatusReport}
            className={styles.deleteBtn}
            type="primary"
          >
            {t("change-status-report-modal.saveButton")}
          </Button>
          <Button className={styles.cancelBtn} onClick={onClose} type="outline">
            {t("change-status-report-modal.cancelButton")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ChangeStatusReportModal;
